import{m as n}from"./chunk-HBP5N4FR.js";n();import s from"bignumber.js";var p=(e,i=!0)=>{let t=String(e);if(!t.match(/^[-]?\d+$/))return!1;let r=new s(t),o=i?0:-1;return r.toString(10)===t&&r.comparedTo(0)>=o};export{p as a};
//# sourceMappingURL=chunk-QFTWB3KE.js.map
